<template>
  <div class="form-panel">
    <p class="form-panel__title"><i class="mdi mdi-filter-variant"></i>Filtrar por</p>
    <div class="form-panel__field">
      <date-picker 
        label="Data inicial"
        dense
        :binding.sync="filter.date"
        :readOnly="false"
      />
    </div>

    <div class="form-panel__field">
      <date-picker 
        label="Data final"
        dense
        :binding.sync="filter.date_end"
        :readOnly="false"
      />
    </div>

    <v-autocomplete
      v-if="user.attributes.kind !== 'partner'"
      class="form-panel__field"
      outlined
      dense
      label="Controlador"
      item-text="name"
      item-value="id"
      :items="partners"
      v-model="filter.partners"
      no-data-text="Nenhum resultado..."
      multiple
      clearable
    ></v-autocomplete>

    <v-autocomplete
      class="form-panel__field"
      outlined
      dense
      label="Criador"
      item-text="name"
      item-value="id"
      :items="creators"
      v-model="filter.person"
      no-data-text="Nenhum resultado..."
      clearable
    ></v-autocomplete>

    <v-select
      v-if="status.length"
      class="form-panel__field"
      outlined
      dense
      label="Status"
      item-text="title"
      item-value="id"
      :items="status"
      v-model="filter.status"
      @change="submit"
      clearable
    ></v-select>

    <div class="form-panel__actions">
      <v-btn 
        class="success"
        @click="submit"
      >
        <i class="mdi mdi-file-chart-outline pr-1"></i>
        Gerar Relatório
      </v-btn>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/layout/DatePicker";

export default {
  name:"ReportFilters",
  props:{
    partners:Array,
    creators:Array,
    status:Array,
    user:Object
  },
  components:{
    DatePicker
  },
  data() {
    return {
      filter:{}
    }
  },
  methods: {
    submit() {
      if(!this.filter.date || !this.filter.date_end) {
        this.$toast.warning("Intervalo de tempo não definido !");
        return
      }
      if(this.user.attributes.kind === 'partner') {
        this.filter.partners = [this.user.attributes.id];
      }
      this.$emit("get-report", this.filter);
    }
  }
}
</script>